/* istanbul ignore file */
import React from 'react';
import { useFieldHelper, PhoneField, TextField } from 'framework/ui/field';

type OpportunityPrimaryContactPhoneFieldProps = {
  label: string;
  phoneNumberSource?: string;
  phoneNumberValue?: string;
  mobilePhoneNumberSource?: string;
  mobilePhoneNumberValue?: string;
};

const OpportunityPrimaryContactPhoneField = ({
  phoneNumberSource,
  phoneNumberValue,
  mobilePhoneNumberSource,
  mobilePhoneNumberValue,
  ...props
}: OpportunityPrimaryContactPhoneFieldProps) => {
  const { getValue: getPhoneNumber } = useFieldHelper({ value: phoneNumberValue, source: phoneNumberSource });
  const { getValue: getMobilePhoneNumber } = useFieldHelper({
    value: mobilePhoneNumberValue,
    source: mobilePhoneNumberSource,
  });

  const phone = getPhoneNumber();
  const mobile = getMobilePhoneNumber();

  return (
    <TextField
      {...props}
      value={
        phone || mobile ? (
          <>
            {phone && <PhoneField value={phone} />}
            {mobile && <PhoneField value={mobile} />}
          </>
        ) : null
      }
    />
  );
};

export default OpportunityPrimaryContactPhoneField;
